import axios from "axios";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import Url from "../../../apiBaseUrl/APIConfig";
import type { GetUserDetailsRes } from "./Model";
import type { LoginBody } from "./Model";
import { setupInterceptorsTo } from "../../authenticationInterceptors/Interceptors";

type InitialState = {
  loading: boolean;
  response: GetUserDetailsRes;
  successMsg: string;
  error: string;
};
const initialState: InitialState = {
  loading: false,
  response: {} as GetUserDetailsRes,
  successMsg: "",
  error: "",
};


export const userLoginDetails = createAsyncThunk<GetUserDetailsRes, LoginBody>(
  "userLoginDetails/userLoginDetails",
  async (payload: LoginBody) => {
    const headers = {
      Accept: "application/json",
      "Content-type": "application/json",
      Authorization: `Bearer ${payload.access}`,
    };
    return await setupInterceptorsTo(axios)
      .get(Url.baseUrl + "/adminapp/api/adminActions/adminLoginDetails", { headers })
      .then((response) => response.data)
  }
);

const userLoginDetailsSlice = createSlice({
  name: "userLoginDetails",
  initialState,
  reducers: {
    updateuserLoginDetailsClearMsg: (state) => {
      state.successMsg = "";
      state.error = "";
    },
    updateuserLoginDetailsClearRes: (state) => {
      state.successMsg = "";
      state.error = "";
      state.response = {} as GetUserDetailsRes;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(userLoginDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      userLoginDetails.fulfilled,
      (state, action: PayloadAction<GetUserDetailsRes>) => {
        state.loading = false;
        state.response = action.payload;
      }
    );
    builder.addCase(userLoginDetails.rejected, (state, action) => {
      state.loading = false;
      state.response = {} as GetUserDetailsRes;
      state.successMsg = "";
      state.error = String(action.payload!);
    });
  },
});
export const { updateuserLoginDetailsClearMsg, updateuserLoginDetailsClearRes } = userLoginDetailsSlice.actions;
export default userLoginDetailsSlice.reducer;
